import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_3 = { class: "badge bg-primary me-2" }
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = {
  key: 0,
  class: "card-body p-3"
}
const _hoisted_6 = { class: "mb-0" }
const _hoisted_7 = {
  key: 0,
  class: "text-center text-muted p-4"
}

import { reactive } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import { historicoVersoes } from "@/data/historicoVersoes";


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const controle = reactive({
  aberto: historicoVersoes.length > 0 ? historicoVersoes[0].versao : null as string | null,
});

function alternar(versao: string) {
  controle.aberto = controle.aberto === versao ? null : versao;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadCrumb, {
      PageTitle: "Histórico de Versões",
      SubTitle: "Sistema"
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(historicoVersoes), (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "card mb-25 border-0 rounded-0 bg-white add-user-card",
        key: item.versao
      }, [
        _createElementVNode("div", {
          class: "card-header",
          style: {"cursor":"pointer"},
          onClick: ($event: any) => (alternar(item.versao))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(item.versao), 1),
              _createElementVNode("span", _hoisted_4, _toDisplayString(item.titulo), 1)
            ]),
            _createElementVNode("i", {
              class: _normalizeClass(["fa", controle.aberto === item.versao ? 'fa-chevron-up' : 'fa-chevron-down'])
            }, null, 2)
          ])
        ], 8, _hoisted_1),
        (controle.aberto === item.versao)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("ul", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.itens, (texto, idx) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: idx,
                    class: "mb-1"
                  }, _toDisplayString(texto), 1))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    (_unref(historicoVersoes).length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Nenhuma versão registrada ainda. "))
      : _createCommentVNode("", true)
  ], 64))
}
}

})